import { IDelegationData } from "@/entities";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IDelegationService } from "./delegation.types";

export class DelegationService implements IDelegationService {
  async getDelegations(): Promise<IDelegationData[] | undefined> {
    const { response, error } = await handleResponse<IDelegationData[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/delegation`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getDelegationsByCountry(
    idCountry: number | undefined
  ): Promise<IDelegationData[] | undefined> {
    const { response, error } = await handleResponse<IDelegationData[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/delegation/` + idCountry)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
